// extracted by mini-css-extract-plugin
export default {"paper":"paper--LB1Ws"};